import { Module, Http, State } from 'shared/core';
import { Injectable } from 'injection-js';
import { AjaxForm } from 'shared/lib';
import { Actions } from 'shared/state';

@Injectable()
export class NameTagsModule extends Module {
  private nameTagValue: JQuery = $('.nameTagValue');
  private nameTagUserValue: JQuery = $('.nameTagUserValue');
  private nameTagNewValue: JQuery = $('.nameTagNewValue');
  private nameTagUserValueOptional: JQuery = $('.nameTagUserValueOptional');
  private nameTagUserSubmit: JQuery = $('.nameTagUserSubmit');
  private nameTagPreview: JQuery = $('.nameTagPreview');

  constructor(
    protected http: Http,
    protected state: State,
  ) {
    super();
  }

  public init(): void {
    this.nameTagUserValue.on('keyup', () => this.checkNameTagsChange());
    this.nameTagUserValueOptional.on('keyup', () => this.checkNameTagsChange());

    this.nameTagUserSubmit.on('click', event => {
      event.preventDefault();
      let child_id = $(event.target).closest('button').data('childId');
      $(`.edit_name_tag[data-child-id="${child_id}"]`).trigger('submit');
    });

    AjaxForm.createGeneral('.edit_name_tag', response => {
      this.setValue(response.child_id, response.text);
    });

    $('body').on('click', '.editNameTag', event => {
      event.preventDefault();
      let childId = $(event.target).closest('a').data('childId');
      this.state.dispatch({ name: Actions.OPEN_STATIC_MODAL, payload: `nametag_text_${childId}_edit` });
      this.checkNameTagsChange();
    });
  }

  private async setValue(child_id: number, text: string): Promise<void> {
    let splitNameTagText = text.split(/\t/);

    if (splitNameTagText.length > 1) {
      this.nameTagUserValue.filter(`[data-child-id="${child_id}"]`).val(splitNameTagText[0]);
      this.nameTagUserValueOptional.filter(`[data-child-id="${child_id}"]`).val(splitNameTagText[1]);
    } else {
      this.nameTagUserValue.filter(`[data-child-id="${child_id}"]`).val(text);
    }

    const $preview = this.nameTagPreview.filter(`[data-child-id="${child_id}"]`).find('span');
    $preview.empty();
    splitNameTagText.forEach((line, index) => {
      if (index > 0) $preview.append('<br/>');
      $preview.append(document.createTextNode(line));
    });

    this.checkNameTagsChange();
    this.state.dispatch( { name: Actions.CLOSE_MODAL });
  }

  private checkNameTagsChange(): void {
    this.nameTagValue.each((index, item) => {
      const child_id = $(item).data('childId');
      let userValue = this.nameTagUserValue.filter(`[data-child-id="${child_id}"]`).val();
      const optionalValue = this.nameTagUserValueOptional.filter(`[data-child-id="${child_id}"]`).val();
      const originalValue = (item as HTMLInputElement).value;
      const submit = this.nameTagUserSubmit.filter(`[data-child-id="${child_id}"]`);

      if (optionalValue != '') {
        userValue = `${userValue}\t${optionalValue}`;
      }

      this.nameTagNewValue.filter(`[data-child-id="${child_id}"]`).val(userValue);

      // If the field is empty, disable select and consider the name tag as "not changing value".
      if (userValue !== originalValue && userValue.toString().trim().length != 0) {
        submit.prop('disabled', false);
      } else {
        // Can't submit name tag with no changes
        submit.prop('disabled', true);
      }
    });
  }
}
